import type { LocaleMessageBundle } from '../../types'

export const orderWebViewMessages: LocaleMessageBundle = {
  vi: {
    'public.order.badge': 'Đặt hàng online',
    'public.order.title': 'Đặt món theo cách của bạn',
    'public.order.subtitle': 'Chọn món yêu thích và gửi yêu cầu đặt hàng nhanh chóng.',
    'public.order.context.table': 'Bàn {code}',
    'public.order.context.store': 'CỬA HÀNG {code}',
    'public.order.context.general': 'Trang đặt hàng công khai',
    'public.order.tenantFallback': 'Cửa hàng',
    'public.order.branch.label': 'Chọn chi nhánh',
    'public.order.catalog.eyebrow': 'Thực đơn',
    'public.order.catalog.title': 'Chọn món',
    'public.order.catalog.search': 'Tìm món...',
    'public.order.catalog.emptyTitle': 'Thực đơn đang được cập nhật',
    'public.order.catalog.emptyDescription':
      'Các sản phẩm online sẽ xuất hiện tại đây ngay khi cửa hàng hoàn tất cấu hình.',
    'public.order.catalog.refresh': 'Làm mới',
    'public.order.catalog.add': 'Thêm món',
    'public.order.catalog.categories': 'Danh mục',
    'public.order.catalog.uncategorized': 'Khác',
    'public.order.catalog.loading': 'Đang tải thực đơn...',
    'public.order.catalog.loadError': 'Không thể tải thực đơn. Vui lòng thử lại.',
    'public.order.cart.eyebrow': 'Đơn của bạn',
    'public.order.cart.title': 'Gọi món',
    'public.order.cart.empty': 'Chưa có sản phẩm nào trong giỏ hàng.',
    'public.order.cart.emptyTitle': 'Chưa có món nào',
    'public.order.cart.total': 'Tạm tính',
    'public.order.cart.submit': 'Gọi món',
    'public.order.cart.note': 'Bạn có thể xem lại đơn trước khi gửi yêu cầu.',
    'public.order.cart.itemNote': 'Ghi chú',
    'public.order.cart.hideItemNote': 'Ẩn ghi chú',
    'public.order.cart.itemNotePlaceholder': 'Ghi chú món...',
    'public.order.payment.request': 'Thanh toán',
    'public.order.payment.confirmTitle': 'Yêu cầu thanh toán',
    'public.order.payment.confirmDesc':
      'Tổng tiền hiện tại: {total}. Nhấn gửi yêu cầu để nhân viên biết và hỗ trợ thanh toán cho bàn.',
    'public.order.payment.confirm': 'Gửi yêu cầu',
    'public.order.payment.cancel': 'Đóng',
    'public.order.payment.success': 'Đã gửi yêu cầu thanh toán. Nhân viên sẽ đến hỗ trợ sớm nhất có thể.',
    'public.order.orderRequest.confirmTitle': 'Gửi yêu cầu gọi món',
    'public.order.orderRequest.confirmDesc':
      'Bạn vừa thêm {count} món mới · Tổng tiền: {total}. Nhấn gửi để nhân viên xác nhận món cho bàn.',
    'public.order.orderRequest.success': 'Đã gửi yêu cầu gọi món. Nhân viên sẽ xác nhận sớm nhất có thể.',
    'public.order.payment.playAndContinue': 'Thanh toán & chơi tiếp',
    'public.order.webview.noNewItems': 'Bạn chưa chọn thêm món mới để gửi.',
    'public.order.webview.posOffline':
      'Lễ tân đang mất kết nối. Vui lòng đợi một lát rồi gửi lại yêu cầu.',
    'public.order.webview.submitError': 'Không gửi được yêu cầu. Vui lòng thử lại.',
    'public.order.webview.cancelled': 'Yêu cầu gọi món vừa bị hủy: {reason}',
    'public.order.webview.removed': 'Món "{name}" đã bị trừ khỏi hóa đơn: {reason}',
    'public.order.webview.paymentSent': 'Đã gửi yêu cầu thanh toán — chờ lễ tân xử lý',
    'public.order.webview.paymentRejected': 'Yêu cầu thanh toán bị từ chối: {reason}',
    'public.order.webview.viewCart': 'Giỏ hàng',
    'public.order.webview.viewHistory': 'Lịch sử',
    'public.order.webview.historyEmpty': 'Chưa có yêu cầu nào được gửi từ bàn này.',
    'public.order.webview.statusPending': 'Chờ',
    'public.order.webview.sourcePos': 'Tại quầy',
    'public.order.webview.sourceWebview': 'Tại bàn',
    'public.order.webview.statusComplete': 'Hoàn thành',
    'public.order.webview.statusCancel': 'Đã hủy',
    'public.order.webview.lineRemoved': 'Đã trừ: {reason}',
    'public.order.webview.lineCancelled': 'Yêu cầu gọi món vừa bị hủy: {reason}',
    'public.order.checkout.submit': 'Đặt hàng',
    'public.order.checkout.title': 'Xác nhận đặt hàng',
    'public.order.checkout.summary': '{count} món · {total}',
    'public.order.checkout.name': 'Họ và tên',
    'public.order.checkout.phone': 'Số điện thoại',
    'public.order.checkout.method': 'Hình thức nhận hàng',
    'public.order.checkout.pickup': 'Nhận tại cửa hàng',
    'public.order.checkout.delivery': 'Giao hàng',
    'public.order.checkout.note': 'Ghi chú',
    'public.order.checkout.address': 'Địa chỉ giao hàng',
    'public.order.checkout.orderNote': 'Ghi chú đơn hàng',
    'public.order.checkout.cancel': 'Đóng',
    'public.order.checkout.nameRequired': 'Vui lòng nhập họ và tên',
    'public.order.checkout.phoneRequired': 'Vui lòng nhập số điện thoại',
    'public.order.checkout.phoneInvalid': 'Số điện thoại không hợp lệ',
    'public.order.checkout.addressRequired': 'Vui lòng nhập địa chỉ giao hàng',
    'public.order.checkout.successTitle': 'Đặt hàng thành công!',
    'public.order.checkout.successDesc':
      'Cảm ơn {name}, nhân viên cửa hàng sẽ liên hệ xác nhận đơn của bạn trong ít phút.',
    'public.order.checkout.newOrder': 'Đặt đơn mới',
    'public.order.footer': 'Powered by BigSale',
  },
  en: {
    'public.order.badge': 'Online ordering',
    'public.order.title': 'Order your way',
    'public.order.subtitle': 'Choose your favorites and send an order request in a few steps.',
    'public.order.context.table': 'Table {code}',
    'public.order.context.store': 'Store {code}',
    'public.order.context.general': 'Public ordering page',
    'public.order.tenantFallback': 'Store',
    'public.order.branch.label': 'Select branch',
    'public.order.catalog.eyebrow': 'Menu',
    'public.order.catalog.title': 'Choose items',
    'public.order.catalog.search': 'Search items...',
    'public.order.catalog.emptyTitle': 'The menu is being updated',
    'public.order.catalog.emptyDescription':
      'Online products will appear here once the store finishes its setup.',
    'public.order.catalog.refresh': 'Refresh',
    'public.order.catalog.add': 'Add item',
    'public.order.catalog.categories': 'Categories',
    'public.order.catalog.uncategorized': 'Other',
    'public.order.catalog.loading': 'Loading menu...',
    'public.order.catalog.loadError': 'Unable to load the menu. Please try again.',
    'public.order.cart.eyebrow': 'Your order',
    'public.order.cart.title': 'Order',
    'public.order.cart.empty': 'There are no items in your cart yet.',
    'public.order.cart.emptyTitle': 'No items yet',
    'public.order.cart.total': 'Subtotal',
    'public.order.cart.submit': 'Order',
    'public.order.cart.note': 'You can review your order before sending the request.',
    'public.order.cart.itemNote': 'Note',
    'public.order.cart.hideItemNote': 'Hide note',
    'public.order.cart.itemNotePlaceholder': 'Item note...',
    'public.order.payment.request': 'Payment',
    'public.order.payment.confirmTitle': 'Request payment',
    'public.order.payment.confirmDesc':
      'Current total: {total}. Send the request so staff can help you check out the table.',
    'public.order.payment.confirm': 'Send request',
    'public.order.payment.cancel': 'Close',
    'public.order.payment.success': 'Payment request sent. A staff member will be with you shortly.',
    'public.order.orderRequest.confirmTitle': 'Send order request',
    'public.order.orderRequest.confirmDesc':
      'You added {count} new item(s) · Total: {total}. Send the request so staff can confirm.',
    'public.order.orderRequest.success': 'Order request sent. Staff will confirm shortly.',
    'public.order.payment.playAndContinue': 'Pay & keep playing',
    'public.order.webview.noNewItems': 'No new items selected to send.',
    'public.order.webview.posOffline':
      'The front desk is currently offline. Please wait a moment and send your request again.',
    'public.order.webview.submitError': 'Could not send the request. Please try again.',
    'public.order.webview.cancelled': 'Your order request was canceled: {reason}',
    'public.order.webview.removed': 'Item "{name}" was removed from the bill: {reason}',
    'public.order.webview.paymentSent': 'Payment request sent — waiting for staff',
    'public.order.webview.paymentRejected': 'Payment request rejected: {reason}',
    'public.order.webview.viewCart': 'Cart',
    'public.order.webview.viewHistory': 'History',
    'public.order.webview.historyEmpty': 'No requests sent from this table yet.',
    'public.order.webview.statusPending': 'Pending',
    'public.order.webview.sourcePos': 'At counter',
    'public.order.webview.sourceWebview': 'At table',
    'public.order.webview.statusComplete': 'Completed',
    'public.order.webview.statusCancel': 'Canceled',
    'public.order.webview.lineRemoved': 'Removed: {reason}',
    'public.order.webview.lineCancelled': 'Canceled: {reason}',
    'public.order.checkout.submit': 'Place order',
    'public.order.checkout.title': 'Confirm your order',
    'public.order.checkout.summary': '{count} items · {total}',
    'public.order.checkout.name': 'Full name',
    'public.order.checkout.phone': 'Phone number',
    'public.order.checkout.method': 'Delivery method',
    'public.order.checkout.pickup': 'Pick up at store',
    'public.order.checkout.delivery': 'Delivery',
    'public.order.checkout.note': 'Note',
    'public.order.checkout.address': 'Delivery address',
    'public.order.checkout.orderNote': 'Order note',
    'public.order.checkout.cancel': 'Cancel',
    'public.order.checkout.nameRequired': 'Please enter your full name',
    'public.order.checkout.phoneRequired': 'Please enter your phone number',
    'public.order.checkout.phoneInvalid': 'Invalid phone number',
    'public.order.checkout.addressRequired': 'Please enter the delivery address',
    'public.order.checkout.successTitle': 'Order placed successfully!',
    'public.order.checkout.successDesc':
      'Thank you {name}, our staff will contact you shortly to confirm your order.',
    'public.order.checkout.newOrder': 'New order',
    'public.order.footer': 'Powered by BigSale',
  },
}
